export default (hasError, isFieldIncluded, fieldName = 'Field') => {
  if (hasError && isFieldIncluded) return `${fieldName} is required`;
  return null;
};
